import React from 'react';
import getFontSize from './private/utils/getFontSize';
import getIconSize from './private/utils/getIconSize';
import getSize from './private/utils/getSize';
import mergeClassnames from '../mergeClassnames/mergeClassnames';
const Tag = ({ children, color, // deprecated
bgColor, // deprecated
iconLeft, iconRight, size = 'xs', isUppercase = true, className, }) => (React.createElement("div", { className: mergeClassnames('flex items-center rounded-moon-i-xs gap-1 select-none text-goku bg-bulma', getSize({ size, iconRight, iconLeft }), getFontSize({ isUppercase, size }), color, bgColor, className) },
    iconLeft && React.createElement("span", { className: getIconSize(size) }, iconLeft),
    children,
    iconRight && React.createElement("span", { className: getIconSize(size) }, iconRight)));
export default Tag;
